import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { membershipPlans } from '@/mocks/homeData';

export default function MembershipCTA() {
  const { t } = useTranslation();
  const [selectedPlan, setSelectedPlan] = useState<string | null>(null);

  const handleSubscribe = () => {
    if (selectedPlan) {
      const plan = membershipPlans.find((p) => p.id === selectedPlan);
      if (plan) {
        window.open('https://readdy.ai/api/form/d9q1dp6e3oq4jqumtf6g', '_blank');
      }
    }
  };

  return (
    <section className="py-16 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-bold text-foreground-950 mb-3">
            {t('membership.title')}
          </h2>
          <p className="text-sm md:text-base text-foreground-600 max-w-lg mx-auto">
            {t('membership.subtitle')}
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 max-w-4xl mx-auto">
          {membershipPlans.map((plan) => (
            <div
              key={plan.id}
              className={`relative rounded-xl p-6 border-2 transition-all cursor-pointer ${
                selectedPlan === plan.id
                  ? 'border-primary-500 bg-primary-50/50'
                  : plan.highlighted
                  ? 'border-accent-500 bg-accent-50/30'
                  : 'border-background-200/70 bg-background-50 hover:border-background-300/60'
              }`}
              onClick={() => setSelectedPlan(plan.id)}
            >
              {plan.badge && (
                <div className="absolute -top-3 left-1/2 -translate-x-1/2 px-3 py-0.5 rounded-full bg-accent-500 text-background-50 text-xs font-bold whitespace-nowrap">
                  {plan.badge}
                </div>
              )}

              <div className="text-center mb-4">
                <h3 className="text-lg font-semibold text-foreground-950 mb-3">{plan.name}</h3>
                <div className="flex items-baseline justify-center gap-0.5">
                  <span className="text-sm text-foreground-500">¥</span>
                  <span className="text-3xl font-bold text-foreground-950">{plan.price}</span>
                  <span className="text-sm text-foreground-500">/{plan.period}</span>
                </div>
                {plan.originalPrice > Number(plan.price) && (
                  <span className="text-xs text-foreground-400 line-through mt-1 block">
                    ¥{plan.originalPrice}/{plan.period}
                  </span>
                )}
              </div>

              <ul className="space-y-2.5 mb-6">
                {plan.features.map((feat, idx) => (
                  <li key={idx} className="flex items-center gap-2 text-sm text-foreground-600">
                    <i className="ri-checkbox-circle-fill text-primary-500 text-sm"></i>
                    {feat}
                  </li>
                ))}
              </ul>

              <button
                onClick={(e) => { e.stopPropagation(); handleSubscribe(); }}
                className={`w-full py-2.5 rounded-full text-sm font-semibold transition-all whitespace-nowrap ${
                  plan.highlighted
                    ? 'bg-accent-500 text-background-50 hover:bg-accent-600'
                    : 'bg-primary-500 text-background-50 hover:bg-primary-600'
                }`}
              >
                {t('membership.cta')}
              </button>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}